/**
 * Codes of the `BasketItem.Info` entries this template writes on add-to-cart.
 *
 * They must match the `Code` values configured in
 * `NORCE_BASKET_ITEM_INFO_TYPES` — `AddToCart` looks the type up by code before
 * writing, so a code that doesn't exist there is silently skipped. Three places
 * depend on them: the writer (`AddToCart.vue`), the GTM item mapper
 * (`useGtmEventsTypes.ts`) and the cart row, which reads size/color to label the
 * line (`variantLabel.ts`). Keeping them here means a rename can't
 * quietly break one of the readers.
 */
export const BASKET_ITEM_INFO_CODES = {
	GROUP_ID: "item_group_id",
	COLOR: "item_color",
	SIZE: "item_size"
} as const;

/** Size first, then color — matches the design ("XS/Fog Grey"). */
export const VARIANT_INFO_CODES = [
	BASKET_ITEM_INFO_CODES.SIZE,
	BASKET_ITEM_INFO_CODES.COLOR
] as const;
